import { useMemo } from 'react'

import { CatalogModel } from 'types/models/catalog'

import { useCatalogContext } from 'pages/Catalog/CatalogProvider'

export const useGetSelectedCatalogs = (): Array<CatalogModel> => {
  const {
    state: { data, filters },
  } = useCatalogContext()
  const { catalogs } = data

  const selectedCatalogs = useMemo(() => {
    const selectedIdsSet = new Set(filters.catalogIds)

    return catalogs.filter(catalog => selectedIdsSet.has(catalog.id))
  }, [catalogs, filters.catalogIds])

  return selectedCatalogs
}
